import { useEffect } from "react";

/**
 * Lúc `active`, đóng tab / tải lại trang / gõ địa chỉ khác thì trình duyệt hỏi
 * lại trước khi rời. Dùng cho mẻ tải ảnh dài: rời trang là ảnh chưa gửi dừng
 * ngay, lỡ tay một cái là mất cả buổi (CEO chốt 02/10/2026).
 *
 * Câu hỏi là của trình duyệt — trình duyệt đời mới không cho trang tự viết câu.
 * Đi giữa các trang TRONG app không qua đây, và cũng không cần: mẻ tải chạy ở
 * tầng app nên vẫn tải tiếp.
 */
export function useWarnBeforeLeave(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      // Chrome cũ chỉ hỏi khi có returnValue.
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [active]);
}
